import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentAccount,
  getCurrentAccountUid,
  selectDefaultMailingAddress,
} from '../../store/selectors/accountSelectors';
import { fetchAccountAddresses } from '../../store/actions/account/accountActions';
import { USA_COUNTRY_ISO3CODE } from '../constants';
import { accountTypes, accountTypeKeys } from '../enum/api/accountTypes';
import { parseEnumType } from '../helpers/enumMappers';

const useSellFromHomeEligibility = () => {
  const dispatch = useDispatch();
  const accountUid = useSelector(getCurrentAccountUid);
  const account = useSelector(getCurrentAccount);
  const mailingAddress = useSelector(selectDefaultMailingAddress);

  useEffect(() => {
    if (accountUid) {
      dispatch(fetchAccountAddresses({ accountUid }));
    }
  }, [dispatch, accountUid]);

  const isNonUS =
    !!mailingAddress && mailingAddress.CountryIso3Code !== USA_COUNTRY_ISO3CODE;
  const isBasicAccount =
    parseEnumType(accountTypeKeys, account?.AccountType) === accountTypes.Basic;

  return { isNonUS, isBasicAccount };
};

export default useSellFromHomeEligibility;
